import React from "react";

// import { useNavigate } from "react-router-dom";

import LogoNex from "../../assets/images/logo-nex-register.png";
import dogHeart from "../../assets/images/dogbook/dog-heart-p2.png";
import DogStarHeart from "../../assets/images/logo-dog-mini-heart.png";
import SuccessStyle from "../../assets/images/success-style.png";
import PrimaryButton from "../../components/button/PrimaryButton";
import { useNavigate } from "react-router-dom";
import TopLogo from "../../components/layout/TopLogo";

export default function CatAddDogSuccess() {
    const navigate = useNavigate();
    return (
        <>
            <TopLogo />
            <div
                style={{
                    minHeight: "calc(100vh - 60px)",
                    padding: "20px",
                    background: "linear-gradient(113.34deg, #213468 16.83%, #213468 39.8%, #1A4984 57.27%, #0D73BB 85.75%, #1B8DCD 97.7%, #2BACE2 108.73%)"

                }}
            >
                <img
                    src={SuccessStyle}
                    alt="logo"
                    style={{ width: "70%", float: "right" }}
                    className="mt-[-20px] mr-[-20px]"
                />
                <div className="mt-[40px] w-full" style={{
                    position: "fixed",
                    left: "50%",
                    transform: "translate(-50%, 0)"
                }}>
                    <div className="text-white text-center  text-[36px] mt-[62px]">
                        เพิ่มน้องหมาในสมุดพกแล้ว
                    </div>
                    <img
                        className="w-[157px] mt-[37px] mb-[70px] mx-auto"
                        src={dogHeart}
                        alt=""
                    />
                    <div className="text-center mt-[50px]">
                        {/*btn member*/}
                        <div className="my-4">
                            <PrimaryButton
                                variant="contained"
                                className="w-[70%] !bg-[#082e683d]"
                                onClick={() => {
                                    navigate("/catbook");
                                }}
                            >
                                กลับไปที่สมุดพกสัตว์เลี้ยง
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
